export interface UploadHistoryWindow {
  windowSize: number;
  windowUnit: "days";
}

export const UPLOAD_HISTORY_WINDOW = {
  windowSize: 30,
  windowUnit: "days",
} satisfies UploadHistoryWindow;
